export const backgroundColorsBasic = {
  default: 'var(--background)',
  gray: 'var(--background-highlight)',
  orange: '#FA9E34',
  yellow: '#F7CC5C',
  green: '#23CFA4',
  blue: '#06C1FF',
  indigo: '#6968F7',
  purple: '#8A24FF',
  pink: '#F54B94',
  red: '#F32E60',
  black: '#000000',
  white: '#ffffff',
};

export const shadowBasic = {
  default: 'var(--shadow-modal-color)',
  gray: 'var(--background-highlight)',
  orange: 'var(--shadow-color-orange)',
  yellow: 'var(--shadow-color-yellow)',
  green: 'var(--shadow-color-green)',
  blue: 'var(--shadow-color-blue)',
  indigo: 'var(--shadow-color-indigo)',
  purple: 'var(--shadow-color-purple)',
  pink: 'var(--shadow-color-pink)',
  red: 'var(--shadow-color-red)',
  black: 'var(--shadow-color-black)',
  white: 'var(--shadow-color-white)',
};
export const colorsGradient = {
  unicorn: 'linear-gradient(135deg, #FFCC33 0%, #E233FF 100%)',
  nebula: 'linear-gradient(135deg, #6699FF 0%, #FF3366 100%)',
  water: 'linear-gradient(135deg, #2F80ED 0%, #B2FFDA 100%)',
  candy: 'linear-gradient(135deg, #CB5EEE 0%, #4BE1EC 100%)',
  melon: 'linear-gradient(135deg, #D6FF7F 0%, #00B3CC 100%)',
};

export const shadowColorsGradient = {
  unicorn: 'var(--shadow-color-unicorn)',
  nebula: 'var(--shadow-color-nebula)',
  water: 'var(--shadow-color-water)',
  candy: 'var(--shadow-color-candy)',
  melon: 'var(--shadow-color-melon)',
};

export const fallbackTextColorsGradient = {
  unicorn: '#F18099',
  nebula: '#B664B0',
  water: '#67B7E5',
  candy: '#9D8EEE',
  melon: '#5CD4AC',
};

export const backgroundColors = {
  ...backgroundColorsBasic,
  ...colorsGradient,
};
export const shadowBackgroundColors = {
  ...shadowBasic,
  ...shadowColorsGradient,
};

export const textColorsBasic = {
  default: 'var(--text-sharp)',
  gray: 'var(--text-light)',
  orange: '#FA9E34',
  yellow: '#F7CC5C',
  green: '#23CFA4',
  blue: '#06C1FF',
  indigo: '#6968F7',
  purple: '#8A24FF',
  pink: '#F54B94',
  red: '#F32E60',
  black: '#000000',
  white: '#ffffff',
};

export const textColors = {
  ...textColorsBasic,
  ...colorsGradient,
};

export const textColorsFallback = {
  ...textColorsBasic,
  ...fallbackTextColorsGradient,
};

export const defaultHighlightColor = 'yellow';

export const DEFAULT_ACCENT_NAME = 'accent';
export const CLEAR_COLOR_NAME = 'clear';
export const DEFAULT_TEXT_ON_ACCENT_NAME = 'text_on_accent';
export const DEFAULT_COLOR_NAME = 'default';
